"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsWelcomeLoginLoginControl = void 0;
const M = require("materialize-css");
const DOM_1 = require("../../../../../../public/js/utils/DOM");
const FormValidator_1 = require("../../../../../../public/js/utils/Validator/FormValidator");
const Form_1 = require("../../../../Form/Form");
const Netwtorking_1 = require("../../../../../../public/js/utils/Netwtorking");
const RequestTypes_1 = require("../../../../../../public/js/definitions/utils/networking/RequestTypes");
const LinkBuilder_1 = require("../../../../../../public/js/utils/LinkBuilder");
const RecoveryControl_1 = require("../RecoveryControl/RecoveryControl");
const codeInput_1 = require("../../../../../../public/js/elements/codeInput");
var ControlsWelcomeLoginLoginControl;
(function (ControlsWelcomeLoginLoginControl) {
    class Config {
        static loginFormId = "frm-login-loginForm";
        static loginFormSubmitId = "buttonLogin";
        static loginControl = "login";
        static loginCallBack = "Login";
        static controlElementId = "LoginControl";
        static showRecoveryId = "showRecovery";
        static showRecoveryCallback = "ShowRecoveryView";
        static verifyCodeBackendCallback = "Verify";
        static twoFactorTokenInputId = "twoFactorToken";
        static twoFactorPhoneInputId = "twoFactorPhone";
        static twoFactorTypeInputId = "twoFactorType";
        static clientIdInputId = "clientId";
        static codeInputId = "loginControlCodeInput";
        static codeInputErrorClassName = "codeInput-error";
    }
    class Control {
        static load() {
            this.triggerLoginForm();
            this.triggerShowRecovery();
        }
        static triggerLoginForm() {
            const formElement = DOM_1.DOM.Parser.getHtmlElement(Config.loginFormId);
            const loginButton = DOM_1.DOM.Parser.getHtmlElement(Config.loginFormSubmitId);
            FormValidator_1.FormValidator.validateForm({ form: formElement, forceSubmitButton: loginButton });
            M.updateTextFields();
            loginButton.addEventListener('click', (event) => {
                void Form_1.ControlsForm.Controller.sendFormDataRequest(formElement, {
                    forceDisabledButtons: [loginButton],
                    linkParameters: { component: Config.loginControl, method: Config.loginCallBack, parameters: [] },
                    formData: Form_1.ControlsForm.Controller.getFormData(formElement),
                    event: event,
                    snippetCallback: (name, element) => {
                        if (element.querySelector('#' + Config.twoFactorTokenInputId)) {
                            this.triggerEnterCodeForm();
                        }
                        else if (element.querySelector('#' + Config.loginFormId)) {
                            this.triggerLoginForm();
                            this.triggerShowRecovery();
                        }
                    }
                });
            });
        }
        static triggerEnterCodeForm() {
            const controlElement = DOM_1.DOM.Parser.getHtmlElement(Config.controlElementId);
            const codeInputElement = DOM_1.DOM.Parser.getHtmlElement(Config.codeInputId, controlElement);
            codeInput_1.CodeInput.init({ finishCallback: (code) => {
                    const twoFactorToken = DOM_1.DOM.Parser.getHtmlElement(Config.twoFactorTokenInputId).value;
                    const twoFactorPhone = DOM_1.DOM.Parser.getHtmlElement(Config.twoFactorPhoneInputId).value;
                    const twoFactorType = DOM_1.DOM.Parser.getHtmlElement(Config.twoFactorTypeInputId).value;
                    const clientId = DOM_1.DOM.Parser.getHtmlElement(Config.clientIdInputId).value;
                    void Netwtorking_1.Networking.NetworkingController.createRequest({
                        type: RequestTypes_1.RequestTypes.POST,
                        data: {
                            twoFactorType: twoFactorType.toString().trim(),
                            twoFactorToken: twoFactorToken.toString().trim(),
                            twoFactorPhone: twoFactorPhone.toString().trim(),
                            code: code,
                            clientId: clientId
                        },
                        url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                            component: Config.loginControl,
                            method: Config.verifyCodeBackendCallback,
                            parameters: [],
                        }),
                        startCallback: () => {
                            codeInput_1.CodeInput.showProgress(codeInputElement);
                            if (document.getElementsByClassName(Config.codeInputErrorClassName).length > 0) {
                                DOM_1.DOM.Parser.getHtmlElementByClass(Config.codeInputErrorClassName, codeInputElement).remove();
                            }
                        },
                        completedCallback: () => {
                            codeInput_1.CodeInput.hideProgress(codeInputElement);
                        },
                        successCallback: () => {
                            this.triggerEnterCodeForm();
                        }
                    });
                } });
        }
        static triggerShowRecovery() {
            DOM_1.DOM.Parser.getHtmlElement(Config.showRecoveryId).addEventListener('click', () => {
                void Netwtorking_1.Networking.NetworkingController.createRequest({
                    type: RequestTypes_1.RequestTypes.GET,
                    url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                        component: null, method: Config.showRecoveryCallback, parameters: [{ name: 'recoveryView', value: 1 }],
                    }),
                    successCallback: () => {
                        RecoveryControl_1.ControlsWelcomeLoginRecoveryControl.Control.load();
                    }
                });
            });
        }
    }
    ControlsWelcomeLoginLoginControl.Control = Control;
})(ControlsWelcomeLoginLoginControl || (exports.ControlsWelcomeLoginLoginControl = ControlsWelcomeLoginLoginControl = {}));
